var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.visible)?_c('button',{staticClass:"inv-btn submit-button",on:{"click":_vm.redirect}},[_c('img',{staticClass:"submit-button__icon",attrs:{"src":require(`@/assets/${_vm.getImageName(_vm.type)}`)}}),_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }